"use client";

import { useTranslations } from "next-intl";
import { usePathname } from "@/i18n/routing";
import { PhoneIcon, DocumentTextIcon } from "@heroicons/react/24/solid";
import { company } from "@/content/global";
import { BookingLink } from "@/components/ui/booking-link";

export function StickyMobileBar() {
  const t = useTranslations("Nav");
  const pathname = usePathname();
  // /preisrechner hat eine eigene mobile Leiste (LpShell → MobileCta).
  if (pathname?.startsWith("/angebot") || pathname?.startsWith("/preisrechner")) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 md:hidden border-t border-line-200 bg-canvas/95 backdrop-blur">
      <div className="grid grid-cols-2">
        <a
          href={company.hotlineHref}
          className="flex flex-col items-center justify-center gap-1 py-3 text-xs font-semibold text-ink-900"
        >
          <PhoneIcon className="h-5 w-5 text-brand-600" aria-hidden />
          {company.hotline}
        </a>
        <BookingLink
          href="/angebot"
          className="flex flex-col items-center justify-center gap-1 py-3 text-xs font-semibold text-white bg-brand-600 border-l border-line-200"
        >
          <DocumentTextIcon className="h-5 w-5" aria-hidden />
          <span className="whitespace-nowrap">{t("ctaQuote")}</span>
        </BookingLink>
      </div>
    </div>
  );
}
